import React from 'react';

const InquiriesTab = ({ inquiries, onDeleteInquiry }) => {
    return (
        <div className="admin-tab-content">
            <div className="admin-card">
                <div className="card-header">
                    <h3>Customer Inquiries ({inquiries.length})</h3>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>Date &amp; Time</th>
                                    <th>Client Name</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Product Interest</th>
                                    <th>Message</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inquiries.map((inq) => (
                                    <tr key={inq.id}>
                                        <td>{new Date(inq.createdAt || Date.now()).toLocaleString()}</td>
                                        <td><strong>{inq.name}</strong></td>
                                        <td>{inq.phone}</td>
                                        <td>{inq.email}</td>
                                        <td><span className="admin-pill bg-orange">{inq.subject || 'General Inquiry'}</span></td>
                                        <td>{inq.message}</td>
                                        <td>
                                            <button className="admin-btn-icon btn-delete" onClick={() => onDeleteInquiry(inq.id)}>
                                                <i className="fa fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InquiriesTab;
